import React, { Component } from 'react';
import { select, easeLinear } from 'd3';
import PropTypes from 'prop-types';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var SORT = {
  vertically: function vertically(a, b) {
    return a.cy - b.cy;
  }, // sort vertically,
  horizontally: function horizontally(a, b) {
    return a.cx - b.cx;
  } // sort vertically


  /**
   * @param {Array} groupOfCircles – An array of circle objects, including `cx`, `cy` (centers), and `r` (radius)
   */
};function getPathFromCircleGroup() {
  var groupOfCircles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var sorter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SORT.vertically;
  var handleSize = arguments[2];
  var v = arguments[3];

  groupOfCircles.forEach(function (circ) {
    circ.c = [circ.cx, circ.cy];
  });

  // get a path segment (curve + arc) between circles
  var pathFromCircles = function pathFromCircles(c, cn, i, len, down) {
    var d = '';

    // Terminal circle should draw arc all the way around
    if (i === len - 1) {
      d += 'C ' + c.h[down ? 0 : 3] + ' ' + c.h[down ? 2 : 1] + ' ' + c.p[down ? 2 : 1] + ' ';
      d += 'A ' + (down ? c.r : c.r1) + ', ' + (down ? c.r : c.r1) + ', 0, 1, 0, ' + c.p[down ? 3 : 0] + ' ';

      if (!down) {
        d += 'Z';
      }

      return d;
    }

    // Starting point, move to (M)
    if (down && i === 0) {
      d += 'M ' + c.p[0] + ' ';
    }

    // Add a bezier cruve (C) and arc (A) between two circles
    d += 'C ' + c.h[down ? 0 : 3] + ' ' + c.h[down ? 2 : 1] + ' ' + c.p[down ? 2 : 1] + ' ';
    d += 'A ' + (down ? c.r : c.r1) + ', ' + (down ? c.r : c.r1) + ', 0, 0, 0, ' + cn.p[down ? 0 : 3] + ' ';

    return d;
  };

  var circles = groupOfCircles.sort(sorter);
  var d = '';

  var pointsAndHandles = circles.map(function (circle, i) {
    return i === circles.length - 1 ? null : curvesBetweenCircles(circle.r, circles[i + 1].r, circle.c, circles[i + 1].c, handleSize, v);
  });

  pointsAndHandles = pointsAndHandles.filter(function (n) {
    return n !== null && n !== undefined;
  }); // remove null & empty

  // draw left and right segments
  pointsAndHandles.forEach(function (c, i) {
    d += pathFromCircles(c, pointsAndHandles[i + 1], i, pointsAndHandles.length, true);
  });
  pointsAndHandles.reverse().forEach(function (c, i) {
    d += pathFromCircles(c, pointsAndHandles[i + 1], i, pointsAndHandles.length, false);
  });

  return d;
}

/**
 * Based on Metaball script by SATO Hiroyuki
 * http://shspage.com/aijs/en/#metaball
 */
function curvesBetweenCircles(radius1, radius2, center1, center2) {
  var handleSize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 2.4;
  var v = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0.5;

  var HALF_PI = Math.PI / 2;
  var d = dist(center1, center2);
  var u1 = 0;
  var u2 = 0;

  if (radius1 === 0 || radius2 === 0 || d <= Math.abs(radius1 - radius2)) {
    return null;
  }

  if (d < radius1 + radius2) {
    u1 = Math.acos((radius1 * radius1 + d * d - radius2 * radius2) / (2 * radius1 * d));

    u2 = Math.acos((radius2 * radius2 + d * d - radius1 * radius1) / (2 * radius2 * d));
  }

  // All the angles
  var angleBetweenCenters = angle(center2, center1);
  var maxSpread = Math.acos((radius1 - radius2) / d);

  var angle1 = angleBetweenCenters + u1 + (maxSpread - u1) * v;
  var angle2 = angleBetweenCenters - u1 - (maxSpread - u1) * v;
  var angle3 = angleBetweenCenters + Math.PI - u2 - (Math.PI - u2 - maxSpread) * v;
  var angle4 = angleBetweenCenters - Math.PI + u2 + (Math.PI - u2 - maxSpread) * v;

  // All the points
  var p1 = getVector(center1, angle1, radius1);
  var p2 = getVector(center1, angle2, radius1);
  var p3 = getVector(center2, angle3, radius2);
  var p4 = getVector(center2, angle4, radius2);

  // Define handle length by the
  // distance between both ends of the curve
  var totalRadius = radius1 + radius2;
  var d2Base = Math.min(v * handleSize, dist(p1, p3) / totalRadius);

  // Take into account when circles are overlapping
  var d2 = d2Base * Math.min(1, d * 2 / (radius1 + radius2));

  var r1 = radius1 * d2;
  var r2 = radius2 * d2;

  var h1 = getVector(p1, angle1 - HALF_PI, r1);
  var h2 = getVector(p2, angle2 + HALF_PI, r1);
  var h3 = getVector(p3, angle3 + HALF_PI, r2);
  var h4 = getVector(p4, angle4 - HALF_PI, r2);

  return {
    p: [p1, p2, p3, p4],
    h: [h1, h2, h3, h4],
    escaped: d > radius1,
    r: radius2,
    r1: radius1
  };
}

/**
 * Utils
 */

function dist(_ref, _ref2) {
  var _ref4 = slicedToArray(_ref, 2),
      x1 = _ref4[0],
      y1 = _ref4[1];

  var _ref3 = slicedToArray(_ref2, 2),
      x2 = _ref3[0],
      y2 = _ref3[1];

  return Math.pow(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2), 0.5);
}

function angle(_ref5, _ref6) {
  var _ref8 = slicedToArray(_ref5, 2),
      x1 = _ref8[0],
      y1 = _ref8[1];

  var _ref7 = slicedToArray(_ref6, 2),
      x2 = _ref7[0],
      y2 = _ref7[1];

  return Math.atan2(y1 - y2, x1 - x2);
}

function getVector(_ref9, a, r) {
  var _ref10 = slicedToArray(_ref9, 2),
      cx = _ref10[0],
      cy = _ref10[1];

  return [cx + r * Math.cos(a), cy + r * Math.sin(a)];
}

var NS = 'ReactMetaballs';

/**
 * Animated Metaball `path`.
 */

var MetaballPath = function (_Component) {
  inherits(MetaballPath, _Component);

  function MetaballPath(props) {
    classCallCheck(this, MetaballPath);

    var _this = possibleConstructorReturn(this, (MetaballPath.__proto__ || Object.getPrototypeOf(MetaballPath)).call(this, props));

    _this.state = {
      path: ''
    };

    _this.pathRef = React.createRef();
    _this.state.path = props.path;
    return _this;
  }

  createClass(MetaballPath, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.path = select(this.pathRef.current);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.props.path === nextProps.path) return;

      var _props = this.props,
          duration = _props.duration,
          _props$easement = _props.easement,
          easement = _props$easement === undefined ? easeLinear : _props$easement;


      this.path.transition().ease(easement).attr('d', nextProps.path).on('end', function () {
        return _this2.setState({
          path: nextProps.path
        });
      }).duration(duration);
    }
  }, {
    key: 'render',
    value: function render() {
      var id = this.props.id;
      var path = this.state.path;


      return React.createElement(
        'g',
        { className: NS + '__pathGroup' },
        React.createElement('path', { className: NS + '__pathGroup__path',
          ref: this.pathRef,
          id: NS + '__path' + id,
          d: path })
      );
    }
  }]);
  return MetaballPath;
}(Component);

MetaballPath.propTypes = {
  easement: PropTypes.any,
  duration: PropTypes.number,
  path: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired
};

var _id = 0;

var compareCircles = function compareCircles(circles, newCircles) {
  if (circles.length !== newCircles.length) return false;
  return circles.every(function (circle, index) {
    return circle.cx === newCircles[index].cx && circle.cy === newCircles[index].cy && circle.r === newCircles[index].r;
  });
};

/**
 * Metaballs: a collection of circles organically joined
 */

var Metaballs = function (_Component) {
  inherits(Metaballs, _Component);

  function Metaballs(props) {
    classCallCheck(this, Metaballs);

    var _this = possibleConstructorReturn(this, (Metaballs.__proto__ || Object.getPrototypeOf(Metaballs)).call(this, props));

    _this.state = {
      viewBox: '',
      circles: []
    };

    _this.updateCircles = function (newCircles) {
      if (compareCircles(_this.props.circles, newCircles)) return;
      _this.setState({
        circles: newCircles
      });
    };

    _this._getViewBox = function () {
      var circles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.circles;
      var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.1;

      var y = circles.map(function (circle) {
        return circle.cy + circle.r;
      });
      var x = circles.map(function (circle) {
        return circle.cx + circle.r;
      });
      return '0 0 ' + Math.round(scale * Math.max.apply(Math, toConsumableArray(x))) + ' ' + Math.round(scale * Math.max.apply(Math, toConsumableArray(y)));
    };

    _this.state.circles = props.circles;
    _this.state.viewBox = _this._getViewBox(props.circles, props.padding);
    _this.state.id = _id++;
    return _this;
  }

  createClass(Metaballs, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.updateCircles(nextProps.circles);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$preserveAspect = _props.preserveAspectRatio,
          preserveAspectRatio = _props$preserveAspect === undefined ? 'xMidYMid meet' : _props$preserveAspect,
          _props$duration = _props.duration,
          duration = _props$duration === undefined ? 750 : _props$duration,
          easement = _props.easement;
      var _state = this.state,
          circles = _state.circles,
          viewBox = _state.viewBox,
          id = _state.id;


      return React.createElement(
        'svg',
        { xmlns: 'http://www.w3.org/2000/svg',
          version: '1.1',
          viewBox: viewBox,
          width: '100%', height: '100%',
          preserveAspectRatio: preserveAspectRatio },
        React.createElement(MetaballPath, { id: id, easement: easement, duration: duration, path: getPathFromCircleGroup(circles) })
      );
    }
  }]);
  return Metaballs;
}(Component);

Metaballs.propTypes = {
  easement: PropTypes.any, // d3
  preserveAspectRatio: PropTypes.string,
  duration: PropTypes.number, // in milliseconds
  padding: PropTypes.number,
  circles: PropTypes.array.isRequired
};
Metaballs.defaultProps = {
  preserveAspectRatio: 'xMidYMid meet',
  duration: 750
};

export default Metaballs;
export { SORT, getPathFromCircleGroup, curvesBetweenCircles };
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-metaballs/dist/index.es.js
// module id = 199
// module chunks = 0